import * as types from './mutation-types'

export const loadDashboardStats = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`dashboard/statistics?startDate=${query.start_date}&endDate=${query.end_date}`).then((response) => {
      commit(types.LOAD_DASHBOARD_STATS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const loadStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`get/statistics?startDate=${query.startDate}&endDate=${query.endDate}`).then((response) => {
      commit(types.LOAD_STATISTICS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const loadSaleStatistics = ({ commit }, query) => {
  return new Promise((resolve, reject) => {
    window.axios.get(`get/sales/statistics?startDate=${query.startDate}&endDate=${query.endDate}`).then((response) => {
      commit(types.LOAD_SALES_STATISTICS, response.data)
      resolve(response)
    }).catch((err) => {
      reject(err)
    })
  })
}

export const getDownloadContactStatistics = ({commit}, query) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`download/contactsSheet?startDate=${query.start_date}&endDate=${query.end_date}&contact_id=${query.contact_id}`, {
        responseType: 'blob'
    }).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const getDownloadDashboardStatistics = ({commit}, query) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`download/statistics/dashboard?startDate=${query.start_date}&endDate=${query.end_date}`, {
        responseType: 'blob'
      }).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}


export const loadWidgets = ({commit}) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`get/widgets`).then((response) => {
        commit(types.LOAD_WIDGETS, response.data.data)

          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  }) 
}

export const loadWidget = ({commit}, params) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`get/${params.id}/widget`, {params}).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const loadUserWidgets = ({commit}) => {
  return new Promise((resolve, reject) => {
      window.axios.get(`get/user-widgets`).then((response) => {
        commit(types.LOAD_USER_WIDGETS, response.data.data)
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const updateModuleWidget = ({commit}, data) => {
  return new Promise((resolve, reject) => {
      window.axios.put(`edit/module/{widget}/widget`, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const saveWidget = ({commit}, data) => {
  return new Promise((resolve, reject) => {
      window.axios.post(`store/user-widget`, data).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}

export const updateUserWidget = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.put(`update/user-widgets`, data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteWidget = ({commit}, id) => {
  return new Promise((resolve, reject) => {
      window.axios.delete(`remove/${id}/user-widget`).then((response) => {
          resolve(response)
      }).catch((err) => {
          reject(err)
      })
  })
}